import * as React from 'react';
export function useViewModel(providedImageSource) {
    const [[currentImageSource, previousImageSource], setCurrentAndPreviousImageSources] = React.useState([providedImageSource, providedImageSource]);
    const [hasImageLoaded, setHasImageLoaded] = React.useState(false);
    React.useEffect(function loadImage() {
        if (providedImageSource === currentImageSource || typeof window === 'undefined')
            return;
        const imageLoader = new window.Image();
        imageLoader.onload = () => setHasImageLoaded(true);
        imageLoader.src = providedImageSource;
        return () => {
            imageLoader.onload = () => undefined;
        };
    }, [currentImageSource, providedImageSource]);
    const [focalImageFlag, setFocalImageFlag] = React.useState(false);
    const toggleFocalImageFlag = React.useCallback(() => {
        setFocalImageFlag(current => !current);
    }, []);
    React.useEffect(function transitionOnceLoaded() {
        if (hasImageLoaded) {
            setCurrentAndPreviousImageSources(([current]) => [providedImageSource, current]);
            toggleFocalImageFlag();
            setHasImageLoaded(false);
        }
    }, [hasImageLoaded, providedImageSource, toggleFocalImageFlag]);
    return {
        currentImageSource,
        focalImageFlag,
        previousImageSource,
    };
}
//# sourceMappingURL=useViewModel.js.map